<template>
  <div id="codeArea" v-if="showCode">
    <AceEditor
      :value="code"
      @init="editorInit"
      lang="python"
      theme="chrome"
    ></AceEditor>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AceEditor from 'vue2-ace-editor'

export default {
  name: 'CodeArea',
  components: {
    AceEditor
  },
  computed: {
    ...mapState(['code', 'showCode'])
  },
  methods: {
    editorInit(editor) {
      require('brace/ext/language_tools')
      require('brace/mode/python')
      require('brace/theme/chrome')
      require('brace/snippets/python')
      editor.setReadOnly(true)
      editor.getSession().setUseWrapMode(true)
      editor.setFontSize(16)
      editor.setShowPrintMargin(false)
      editor.renderer.$cursorLayer.element.style.display = 'none'
      editor.textInput.getElement().setAttribute('readonly', 'readonly')
    }
  }
}
</script>

<style>
#codeArea {
  position: absolute;
  left: 0;
  top: 56px;
  display: block;
  width: 100%;
  height: calc(100% - 56px);
  background-color: white;
  z-index: 80;
  transition: 0.5s;
}

.showSideBar #codeArea {
  left: 275px;
  width: calc(100% - 275px);
}

#codeArea .ace-chrome .ace_gutter-active-line,
#codeArea .ace-chrome .ace_marker-layer .ace_active-line {
  background-color: unset;
}

@media only screen and (max-width: 600px) {
  #codeArea {
    left: 39px;
    width: calc(100% - 39px);
  }
}
</style>
